import { render, staticRenderFns } from "./TransportationPartnerDetail.vue?vue&type=template&id=02ee2a23&scoped=true"
import script from "./TransportationPartnerDetail.vue?vue&type=script&lang=js"
export * from "./TransportationPartnerDetail.vue?vue&type=script&lang=js"
import style0 from "./TransportationPartnerDetail.vue?vue&type=style&index=0&id=02ee2a23&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02ee2a23",
  null
  
)

export default component.exports